
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import buscador from './lista-buscador.vue';
    import opciones_listado from './lista-buscador-opciones-listado.vue';
    import listado from './lista-listado.vue';
    import barra from './barra-lateral.vue';
    import paginacion from './lista-listado-paginacion.vue';
    import filtros_activos from './lista-buscador-filtros-activos.vue';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            buscador,
            barra,
            listado,
            filtros_activos,
            paginacion,
            opciones_listado
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( this.Controlador.onEjecutar.subscribe( () => { this.Ejecutar(); } ) );
            //this.Controlador.Buscador.Filtros.set( this.$route.query );
            //this.Controlador.Buscador.Buscar();

        }


        public Errores: any[] = [];
        public CargandoSincronizarTodo: boolean = false;
        public TotalSincronizarTodo: number = 0;
        public IdSincronizarTodo: number = 0;
        public VaSincronizarTodo: number = 0;
        public SocketSincronizarTodo: string = '';
        async ActualizarSincronizarTodo( e: any )
        {
            if ( e.end )
            {
                this.$socket.client.off( this.SocketSincronizarTodo );
                this.CargandoSincronizarTodo = false;
                await Wait( 100 );
                //this.Controlador.Buscador.Buscar( 1 );
                Utiles.Notificaciones.Completado( 'Sincronización completada' );
            } else
            {
                if ( e.error )
                {
                    this.Errores.push( { id: e.id } );
                }

                this.VaSincronizarTodo = e.descargados;
                this.IdSincronizarTodo = e.id;
            }

        }

        async Ejecutar()
        {
            this.CargandoSincronizarTodo = true;
            let e = await Publicacion.ModificarPrecios( this.Controlador.Coeficiente, this.Buscador.Parametros );
            if ( e )
            {
                this.TotalSincronizarTodo = e.Total;
                this.SocketSincronizarTodo = 'sincro-ml-' + e.Proceso;
                this.$socket.client.on( this.SocketSincronizarTodo, this.ActualizarSincronizarTodo );


            } else
            {
                Utiles.Notificaciones.Error( 'Error al buscar las publicaciones' );
            }
        }


    }
